import api from "../axios/api";
import { IPayload } from "../models/ipayload";
import Axios from "axios";
import { IArea } from "../models/iarea";
let CancelToken = Axios.CancelToken;
let fetchAreas_cancel: any


export const fetchAreas = (page: number, limit: number, search: string, order: string, orderBy: string): Promise<IPayload<IArea>> => {
    fetchAreas_cancel && fetchAreas_cancel()

    const queryParams = `?page=${!page || page < 1 ? 1 : page}&limit=${!limit || limit < 5 ? 5 : limit}&q=${search ? search : ''}&sort=${order === 'desc' ? '-' : ''}${orderBy}}`;
    return api.get('/areas' + queryParams, {
      cancelToken: new CancelToken(function executor(c) {
        fetchAreas_cancel = c;
      })
    })
}

